export default class SuluForm {
    constructor(el) {
        this.DOM = { el: el };
        this.DOM.button = this.DOM.el.querySelector('.btn-sulu-form');

        this.initEvents();
    }

    initEvents() {
        this.DOM.el.addEventListener("submit", () => {
            if (this.DOM.el.checkValidity()) this.DOM.button.disabled = true;
        });
    }
}

const suluFormNodes = Array.from(document.querySelectorAll('.sulu-form'));
if (suluFormNodes !== null) {
    suluFormNodes.forEach((node) => { new SuluForm(node); });
}
